import { createContext, useContext } from 'react';

type OverlayContextValue = {
  headerShadow: boolean;
  footerShadow: boolean;
};

const OverlayContext = createContext<OverlayContextValue>({
  headerShadow: false,
  footerShadow: false,
});

export const useOverlayContext = () => useContext(OverlayContext);
export default OverlayContext;
